import api from '../api';
import appUserStorage from './app-user-storage';

export function login(email: string, password: string, remember: boolean): Promise<void> {
  const data = {
    email, password, remember,
  };
  return api
    .post('auth/login', data)
    .then((response) => {
      appUserStorage.write(response.data.user);
    });
}

export function logout(): Promise<void> {
  return api
    .put('auth/logout')
    .then(() => {
      appUserStorage.clear();
    });
}

let refreshTask;
export function refreshAccessToken(): Promise<void> {
  if (refreshTask) return refreshTask;
  refreshTask = api.post('auth/refresh');
  refreshTask.finally(() => {
    refreshTask = null;
  });
  return refreshTask;
}
